var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.editGroup
      ? _c("div", [
          _c("table", { staticClass: "table table-sm mt-0 table-hover" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.editGroup.data, function (r, groupIndex) {
                  return [
                    _c("tr", { staticClass: "first_block_tr" }, [
                      _c(
                        "td",
                        {
                          attrs: {
                            rowspan:
                              r.users.shift_1.length * (_vm.usersRows + 1) + 1,
                          },
                        },
                        [
                          _c("p", [
                            _vm._v(_vm._s(r.group?.title ?? "no title")),
                          ]),
                          _vm._v(" "),
                          r.group?.data?.projects
                            ? [
                                _c(
                                  "p",
                                  _vm._l(
                                    r.group.data.projects,
                                    function (p, i) {
                                      return _c("span", [
                                        _vm._v(
                                          _vm._s(i !== 0 ? ", " : "") +
                                            _vm._s(_vm.$AllProjects[p]?.title)
                                        ),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ]
                            : [_c("p", [_vm._v("Все проекты")])],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("td", {
                        staticClass: "empty_td",
                        attrs: { colspan: "4" },
                      }),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          attrs: {
                            rowspan:
                              r.users.shift_1.length * (_vm.usersRows + 1) + 1,
                          },
                        },
                        [
                          _c("p", [
                            _vm._v(_vm._s(_vm.schedule[r.schedule]?.start)),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(_vm._s(_vm.schedule[r.schedule]?.end)),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(r.users.shift_1, function (u, i) {
                      return [
                        _c("tr", [
                          _c(
                            "td",
                            { attrs: { rowspan: _vm.usersRows + 1 } },
                            [
                              u?.id
                                ? [
                                    _c("strong", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(u?.id) +
                                          ") " +
                                          _vm._s(
                                            u?.id === -1
                                              ? "Вся группа"
                                              : u?.name
                                          )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("i", [_vm._v(_vm._s(u?.role))]),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("td", {
                            staticClass: "empty_td",
                            attrs: { colspan: "2" },
                          }),
                          _vm._v(" "),
                          _c(
                            "td",
                            { attrs: { rowspan: _vm.usersRows + 1 } },
                            [
                              r.users.shift_2[i]?.id
                                ? [
                                    _c("strong", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(r.users.shift_2[i]?.id) +
                                          ")\n                  " +
                                          _vm._s(
                                            r.users.shift_2[i]?.id === -1
                                              ? "Вся группа"
                                              : r.users.shift_2[i]?.name
                                          )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("i", [
                                      _vm._v(_vm._s(r.users.shift_2[i]?.role)),
                                    ]),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tr",
                          _vm._l([1, 2], function (shift) {
                            return _c(
                              "td",
                              [
                                _vm.usersStats[
                                  r.users["shift_" + shift][i]?.id
                                ]?.[r.schedule]
                                  ? [
                                      _c("p", [
                                        _vm._v("Заявок: "),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.usersStats[
                                                r.users["shift_" + shift][i].id
                                              ][r.schedule].total_orders
                                            )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "Всего звонков:\n                  "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.usersStats[
                                                r.users["shift_" + shift][i].id
                                              ][r.schedule].total_calls
                                            )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "Всего минут:\n                  "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.usersStats[
                                                r.users["shift_" + shift][i].id
                                              ][r.schedule].total_call_duration
                                            )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v("На сумму:\n                  "),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.usersStats[
                                                r.users["shift_" + shift][i].id
                                              ][r.schedule].total_price
                                            )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "Сумма по коэфф:\n                  "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.usersStats[
                                                r.users["shift_" + shift][i].id
                                              ][r.schedule].total_price_by_rate
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [_vm._v(_vm._s(r.schedule))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(r.users.shift_2[i]?.id))]),
                        ]),
                      ]
                    }),
                  ]
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          false
            ? _c("table", { staticClass: "table table-sm table-hover mt-1" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.editGroup.data, function (r, groupIndex) {
                      return !r.to_delete
                        ? [
                            _c("tr", { staticClass: "first_block_tr" }, [
                              _c(
                                "td",
                                {
                                  attrs: {
                                    rowspan:
                                      r.users.shift_1.length *
                                        (_vm.rowspanUser + 1) +
                                      1,
                                  },
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(r.group?.title ?? "no title")
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  r.group?.data?.projects
                                    ? [
                                        _c(
                                          "p",
                                          _vm._l(
                                            r.group.data.projects,
                                            function (p, i) {
                                              return _c("span", [
                                                _vm._v(
                                                  _vm._s(i !== 0 ? ", " : "") +
                                                    _vm._s(
                                                      _vm.$AllProjects[p]?.title
                                                    )
                                                ),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    : [_c("p", [_vm._v("Все проекты")])],
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("td", {
                                staticClass: "empty_td",
                                attrs: { colspan: "9" },
                              }),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  attrs: {
                                    rowspan:
                                      r.users.shift_1.length *
                                        (_vm.rowspanUser + 1) +
                                      1,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.schedule[r.schedule].start.substring(
                                        0,
                                        _vm.schedule[r.schedule].start.length -
                                          3
                                      )
                                    ) +
                                      " - " +
                                      _vm._s(
                                        _vm.schedule[r.schedule].end.substring(
                                          0,
                                          _vm.schedule[r.schedule].end.length -
                                            3
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(r.users.shift_1, function (u, i) {
                              return [
                                _c("tr", [
                                  _c(
                                    "td",
                                    { attrs: { rowspan: _vm.rowspanUser + 1 } },
                                    [
                                      r.users.shift_1[i]?.id
                                        ? [
                                            _c("strong", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    r.users.shift_1[i]?.id
                                                  ) +
                                                  ") " +
                                                  _vm._s(
                                                    r.users.shift_1[i]?.id ===
                                                      -1
                                                      ? "Вся группа"
                                                      : r.users.shift_1[i]?.name
                                                  )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("i", [
                                              _vm._v(
                                                _vm._s(r.users.shift_1[i]?.role)
                                              ),
                                            ]),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("td", {
                                    staticClass: "empty_td",
                                    attrs: { colspan: "7" },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { attrs: { rowspan: _vm.rowspanUser + 1 } },
                                    [
                                      r.users.shift_2[i]?.id
                                        ? [
                                            _c("strong", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    r.users.shift_2[i]?.id
                                                  ) +
                                                  ") " +
                                                  _vm._s(
                                                    r.users.shift_2[i]?.id ===
                                                      -1
                                                      ? "Вся группа"
                                                      : r.users.shift_2[i]?.name
                                                  )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("i", [
                                              _vm._v(
                                                _vm._s(r.users.shift_2[i]?.role)
                                              ),
                                            ]),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.rowspanUser, function (ii) {
                                  return [
                                    ii === 1
                                      ? [
                                          _c(
                                            "tr",
                                            { staticClass: "tr_total_orders" },
                                            [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    colspan: "7",
                                                    align: "center",
                                                  },
                                                },
                                                [
                                                  _c("p", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.getSum(
                                                          "total",
                                                          "orders",
                                                          i,
                                                          r
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.usersStatsList[ii - 2]?.type ===
                                    "orders"
                                      ? [
                                          _c("tr", [
                                            _c("td", [
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    _vm.usersStatsList[ii - 2]
                                                      .span,
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.usersStatsList[ii - 2]
                                                        .abbreviation
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "total_order_figures",
                                              },
                                              [
                                                _c("p", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.getSum(
                                                        _vm.usersStatsList[
                                                          ii - 2
                                                        ].alias,
                                                        "total",
                                                        i,
                                                        r,
                                                        1
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("td", { staticClass: "bg_1" }, [
                                              _c("p", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.getSum(
                                                      _vm.usersStatsList[ii - 2]
                                                        .alias,
                                                      "sum",
                                                      i,
                                                      r,
                                                      1
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", {}, [
                                              _c("p", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.getSum(
                                                      _vm.usersStatsList[ii - 2]
                                                        .alias,
                                                      "grand_total",
                                                      i,
                                                      r,
                                                      1
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", {}, [
                                              _c("p", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.getSum(
                                                      _vm.usersStatsList[ii - 2]
                                                        .alias,
                                                      "grand_sum",
                                                      i,
                                                      r,
                                                      1
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", { staticClass: "bg_1" }, [
                                              _c("p", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.getSum(
                                                      _vm.usersStatsList[ii - 2]
                                                        .alias,
                                                      "sum",
                                                      i,
                                                      r,
                                                      2
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "total_order_figures",
                                              },
                                              [
                                                _c("p", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.getSum(
                                                        _vm.usersStatsList[
                                                          ii - 2
                                                        ].alias,
                                                        "total",
                                                        i,
                                                        r,
                                                        2
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      : _vm._e(),
                                  ]
                                }),
                              ]
                            }),
                          ]
                        : _vm._e()
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          false
            ? _c("table", { staticClass: "table table-sm table-hover mt-1" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("Группа")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("проекты")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("смена 1")]),
                    _vm._v(" "),
                    _c("th", {
                      class: { stat_td: !!_vm.stats },
                      attrs: { colspan: "3" },
                    }),
                    _vm._v(" "),
                    _c("th", [_vm._v("смена 2")]),
                    _vm._v(" "),
                    _c("th", { staticClass: "w-small" }, [_vm._v("график")]),
                    _vm._v(" "),
                    _c("th"),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.editGroup.data, function (r, ii) {
                      return !r.to_delete
                        ? [
                            _c(
                              "tr",
                              { class: { gray: ii % 2 } },
                              [
                                _c(
                                  "td",
                                  {
                                    attrs: {
                                      rowspan: _vm.groupRowSpan[r.group.id],
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.allGroups.find(
                                            (g) => g.id === r.group.id
                                          )?.title
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    attrs: {
                                      rowspan: _vm.groupRowSpan[r.group.id],
                                    },
                                  },
                                  [
                                    r?.group?.data?.projects
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex_gap_10 flex-wrap",
                                            },
                                            _vm._l(
                                              r.group.data.projects,
                                              function (p) {
                                                return _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-info",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n              " +
                                                        _vm._s(
                                                          _vm.$AllProjects[p]
                                                            ?.title
                                                        ) +
                                                        "\n            "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            "\n              Все проекты\n            "
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                !!_vm.stats
                                  ? [
                                      _c("td"),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _c("ShiftOrdersStat", {
                                            attrs: {
                                              allRecords:
                                                _vm.stats[r.schedule] ?? {},
                                              allUsers: [
                                                ...r.users.shift_1,
                                                ...r.users.shift_2,
                                              ],
                                              users: r.users.shift_1,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("td"),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _c("ShiftOrdersStat", {
                                            attrs: {
                                              allRecords:
                                                _vm.stats[r.schedule] ?? {},
                                              allUsers: [
                                                ...r.users.shift_1,
                                                ...r.users.shift_2,
                                              ],
                                              users: r.users.shift_2,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("td"),
                                    ]
                                  : [
                                      _c("td", {
                                        staticClass: "empty_td",
                                        attrs: { colspan: "5" },
                                      }),
                                    ],
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    attrs: {
                                      rowspan: _vm.groupRowSpan[r.group.id],
                                    },
                                  },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: r.schedule,
                                            expression: "r.schedule",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: { disabled: !!_vm.editGroup.id },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              r,
                                              "schedule",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: { value: "0", disabled: "" },
                                          },
                                          [_vm._v("Выберите график")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.schedule, function (s) {
                                          return _c(
                                            "option",
                                            { domProps: { value: s.id } },
                                            [
                                              _vm._v(
                                                _vm._s(s.start) +
                                                  " - " +
                                                  _vm._s(s.end) +
                                                  " " +
                                                  _vm._s(s.title)
                                              ),
                                            ]
                                          )
                                        }),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm._l(
                              _vm.groupRowSpan[r.group.id] - 1,
                              function (i) {
                                return _c("tr", { class: { gray: ii % 2 } }, [
                                  _c("td", [
                                    r.users?.shift_1?.[i - 1]
                                      ? _c("span", [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                r.users.shift_1[i - 1]?.id
                                              ) +
                                              ") " +
                                              _vm._s(
                                                r.users.shift_1[i - 1]?.name
                                              ) +
                                              " (" +
                                              _vm._s(
                                                r.users.shift_1[i - 1]?.role
                                              ) +
                                              ")"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.printUserStat(
                                              _vm.stats[r.schedule]?.[
                                                r.users.shift_1[i - 1]?.id
                                              ] ?? {}
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _vm.stats && r.users?.shift_1?.[i - 1]
                                        ? _c("ManagerOrdersStats", {
                                            attrs: {
                                              allShift: _vm.getAllShiftStats(
                                                r,
                                                1
                                              ),
                                              stats:
                                                _vm.stats[r.schedule]?.[
                                                  r.users.shift_1[i - 1]?.id
                                                ] ?? {},
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _vm.stats &&
                                      (r.users?.shift_1?.[i - 1] ||
                                        r.users?.shift_2?.[i - 1])
                                        ? _c("ManagerOrdersStatsDiff", {
                                            attrs: {
                                              stats1:
                                                _vm.stats[r.schedule]?.[
                                                  r.users.shift_1[i - 1]?.id
                                                ] ?? {},
                                              stats2:
                                                _vm.stats[r.schedule]?.[
                                                  r.users.shift_2[i - 1]?.id
                                                ] ?? {},
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _vm.stats && r.users?.shift_2?.[i - 1]
                                        ? _c("ManagerOrdersStats", {
                                            attrs: {
                                              allShift: _vm.getAllShiftStats(
                                                r,
                                                2
                                              ),
                                              stats:
                                                _vm.stats[r.schedule]?.[
                                                  r.users.shift_2[i - 1]?.id
                                                ] ?? {},
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("td", [
                                    r.users?.shift_2?.[i - 1]
                                      ? _c("span", [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                r.users.shift_2[i - 1]?.id
                                              ) +
                                              ") " +
                                              _vm._s(
                                                r.users.shift_2[i - 1]?.name
                                              ) +
                                              " (" +
                                              _vm._s(
                                                r.users.shift_2[i - 1]?.role
                                              ) +
                                              ")"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.printUserStat(
                                              _vm.stats[r.schedule]?.[
                                                r.users.shift_2[i - 1]?.id
                                              ] ?? {}
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ])
                              }
                            ),
                          ]
                        : _vm._e()
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.editGroup.id
            ? _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "Сохранить",
                      type: "button",
                      loading: _vm.loading,
                      onClick: () => _vm.saveGroup(),
                      color: _vm.$constants.SUCCESS_COLOR,
                      className: "btn btn-outline-success",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("группа")]),
        _vm._v(" "),
        _c("th", [_vm._v("смена 1")]),
        _vm._v(" "),
        _c("th", { staticClass: "mw_ht" }, [_vm._v("кол.")]),
        _vm._v(" "),
        _c("th", { staticClass: "mw_ht" }, [_vm._v("кол.")]),
        _vm._v(" "),
        _c("th", [_vm._v("смена 2")]),
        _vm._v(" "),
        _c("th", [_vm._v("график")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("группа")]),
        _vm._v(" "),
        _c("th", [_vm._v("смена 1")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", { staticClass: "mw_ht" }, [_vm._v("кол.")]),
        _vm._v(" "),
        _c("th", { staticClass: "mw_ht" }, [_vm._v("сумм.")]),
        _vm._v(" "),
        _c("th", { staticClass: "mw_ht" }, [_vm._v("кол.об")]),
        _vm._v(" "),
        _c("th", { staticClass: "mw_ht" }, [_vm._v("сумм.об")]),
        _vm._v(" "),
        _c("th", { staticClass: "mw_ht" }, [_vm._v("сумм.")]),
        _vm._v(" "),
        _c("th", { staticClass: "mw_ht" }, [_vm._v("кол.")]),
        _vm._v(" "),
        _c("th", [_vm._v("смена 2")]),
        _vm._v(" "),
        _c("th", [_vm._v("график")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }